import React, { useState } from 'react';
import { HStack, Pressable, Text, Button, useTheme } from 'native-base';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faMessagePlus, faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons';
import SearchForumModal from '../../search/SearchForumModal';
import NotificationPopover from '../../notification/NotificationPopover';
const MenuHeader = props => {
  const theme = useTheme(),
    {
      colors
    } = theme;
  const [showSearchModal, setShowSearchModal] = useState(false);
  const OverviewFontAwesomeIcon = _ref => {
    let {
      icon,
      color
    } = _ref;
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: icon,
      color: color
    });
  };
  const newTopicButtonClicked = () => {
    props.startNewTopicButtonRef.current.click();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, showSearchModal && /*#__PURE__*/React.createElement(SearchForumModal, {
    navigation: props.navigation,
    showSearchModal: showSearchModal,
    setShowSearchModal: setShowSearchModal
  }), /*#__PURE__*/React.createElement(HStack, {
    w: '100%',
    p: 1,
    m: 1
  }, /*#__PURE__*/React.createElement(Button, {
    onPress: () => newTopicButtonClicked(),
    rounded: '3xl',
    px: 10,
    mr: 2,
    bg: colors.menu.header.newTopic.bg,
    borderColor: colors.menu.header.newTopic.border,
    borderWidth: 2,
    colorScheme: 'default',
    _hover: {
      bg: colors.menu.header.newTopic.hover.bg
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(OverviewFontAwesomeIcon, {
    icon: faMessagePlus,
    color: colors.menu.header.newTopic.border
  }), /*#__PURE__*/React.createElement(Text, {
    ml: 2,
    color: colors.menu.header.newTopic.text
  }, "New Topic"))), /*#__PURE__*/React.createElement(Pressable, {
    bg: colors.menu.header.button.icon.bg,
    rounded: '3xl',
    p: 3,
    m: 2,
    onPress: () => setShowSearchModal(true),
    borderColor: colors.menu.header.button.border,
    borderWidth: 1
  }, /*#__PURE__*/React.createElement(OverviewFontAwesomeIcon, {
    icon: faMagnifyingGlass,
    color: colors.menu.header.button.icon.text
  })), /*#__PURE__*/React.createElement(NotificationPopover, {
    navigation: props.navigation
  })));
};
export default MenuHeader;
//# sourceMappingURL=MenuHeader.js.map